import { MutationKey } from '@tanstack/query-core';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { AppID, SpaceID } from '@playq/octopus-common';
import { AppEntityClass } from '@playq/octopus2-apps';
import { PromotionSource } from '@playq/octopus2-apps-utility';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';
import { experimentsQueryKeys } from '/api/hooks/experimentsService';
import { flowQueryKeys } from '/api/hooks/flows';
import { gameEventsQueryKeys } from '/api/hooks/gameEventsService';
import { snackbarService } from '/common/snackbarService';

import { spacePromotionsCopyKey } from './constants';

export type UseAppSpacePromotionsCopyParams = {
  appID: AppID;
  source: PromotionSource;
  targetSpaceID: SpaceID;
  entities: AppEntityClass[];
};

export const useAppSpacePromotionsCopy = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UseAppSpacePromotionsCopyParams>
) => {
  return useEitherMutation(
    ({ appID, source, targetSpaceID, entities }) =>
      services2.spacesPromotionsService.copyPromotions(appID, source, targetSpaceID, entities),
    {
      onSuccess: () => {
        snackbarService.success('Selected entities successfully copied to selected space');
      },
      removeQueriesKeysArray: [experimentsQueryKeys, flowQueryKeys, gameEventsQueryKeys],
      mutationKey: spacePromotionsCopyKey as MutationKey,
      ...options,
    }
  );
};
